var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.list),function(i,idx){return _c('IBPaymentCardButton',_vm._b({key:'btn-item-' + idx},'IBPaymentCardButton',i,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }